import React, { useState, useEffect } from 'react';

import Button from './ui/Button';

const SessionStatusIndicator = ({ sessionActive = false, sessionData = null }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [sessionDuration, setSessionDuration] = useState(0);

  useEffect(() => {
    if (!sessionActive || !sessionData?.startTime) return;

    const interval = setInterval(() => {
      const now = new Date();
      const start = new Date(sessionData.startTime);
      const diffMs = now - start;
      const diffMins = Math.floor(diffMs / 60000);
      setSessionDuration(diffMins);
    }, 1000);

    return () => clearInterval(interval);
  }, [sessionActive, sessionData]);

  const handleEndSession = () => {
    if (window.confirm('Are you sure you want to end this session?')) {
      console.log('Ending session...');
    }
  };

  const handleEmergency = () => {
    if (window.confirm('This will alert emergency services. Continue?')) {
      console.log('Emergency alert triggered');
    }
  };

  const formatDuration = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
  };

  if (!sessionActive) return null;

  return (
    <div className="session-indicator">
      <div className="session-indicator-header">
        <div className="session-indicator-status">
          <span className="session-indicator-pulse" />
          <span className="text-success">Session Active</span>
        </div>
        <Button
          variant="ghost"
          size="icon"
          iconName={isExpanded ? 'ChevronDown' : 'ChevronUp'}
          onClick={() => setIsExpanded(!isExpanded)}
        />
      </div>
      {isExpanded && (
        <>
          <div className="space-y-2 mb-3">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Duration</span>
              <span className="font-medium text-data">{formatDuration(sessionDuration)}</span>
            </div>
            {sessionData?.helperName && (
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">With</span>
                <span className="font-medium">{sessionData?.helperName}</span>
              </div>
            )}
          </div>

          <div className="session-indicator-controls">
            <Button
              variant="outline"
              size="sm"
              iconName="Settings"
              iconPosition="left"
              fullWidth
            >
              Settings
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="PhoneOff"
              iconPosition="left"
              onClick={handleEndSession}
              fullWidth
            >
              End
            </Button>
          </div>

          <div className="mt-3 pt-3 border-t border-border">
            <Button
              variant="ghost"
              size="sm"
              iconName="AlertTriangle"
              iconPosition="left"
              onClick={handleEmergency}
              fullWidth
              className="text-error hover:text-error hover:bg-error/10"
            >
              Emergency Alert
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default SessionStatusIndicator;